module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录-试听课成功预约提醒记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "maxlength": 10
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读"
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所处年级:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.grades
    },
    on: {
      "on-select-change": _vm.onGradeChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习经历:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.studyExperience
    },
    on: {
      "on-select-change": _vm.onStudyExperienceChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "孩子性格:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.studentNature
    },
    on: {
      "on-select-change": _vm.onStudentNature
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "兴趣爱好:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.hobby
    },
    on: {
      "on-select-change": _vm.onHobbyChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师要求:"
    }
  }, [_c('CheckBox', {
    attrs: {
      "boxList": _vm.tchRequirement
    },
    on: {
      "on-select-change": _vm.ontchRequirementChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期",
      "value": _vm.formData.nextTimeDate
    },
    on: {
      "on-change": _vm.dateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.state),
      callback: function($$v) {
        _vm.$set(_vm.formData, "state", _vm._n($$v))
      },
      expression: "formData.state"
    }
  }, _vm._l((_vm.$constant.handlerType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a94f6c4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/EditStudentInfo.vue
// module id = 1675
// module chunks = 8